import React, { useEffect, useCallback, useMemo, lazy, Suspense } from "react";
import { useSelector } from "react-redux";
import { Col } from "react-bootstrap";

import MatomoTrackerAction from "../../matomoTracking/MatomoTrackerAction";

import FilePdf from "../../img/pdf.svg";
import { DEFAULT_LANG } from "../../config/Constant";
import HomeContentLoader from "../../component/HomeContentLoader";

// ✅ Lazy load non-critical components
const AboutUs = lazy(() => import("./AboutUs"));
const NewBanner = lazy(() => import("./NewBanner"));
const FarmerLogin = lazy(() => import("./FarmerLogin"));
const Services = lazy(() => import("./Services"));
const UsePortal = lazy(() => import("../../hooks/UsePortal"));

function Index() {
  const CMSData = useSelector((state) => state.cmsdatadetail.cmsdatadetail);
  const { trackEvent } = MatomoTrackerAction();

  const selectedLanguage = useMemo(
    () => localStorage.getItem("lang") || DEFAULT_LANG,
    []
  );

  const pdfItems = useMemo(() => {
    return [
      CMSData?.farmer_onoboarding_en,
      CMSData?.farmer_onoboarding_ori,
      CMSData?.user_manual_en,
      CMSData?.user_manual_ori,
    ].filter(Boolean); // removes any undefined/null
  }, [CMSData]);

  useEffect(() => {
    trackEvent("Home Page Screen", "home", "Home Page", 1);
  }, [trackEvent]);

  const renderPDFLink = useCallback(
    (item) => {
      if (!item?.title_en) return null;

      const title =
        selectedLanguage === "ori" ? item?.title_ori : item?.title_en;
      const description =
        selectedLanguage === "ori"
          ? item?.description_ori
          : item?.description_en;

      return (
        <li key={item?.logo}>
          <a href={item?.logo} target="_blank" rel="noopener noreferrer">
            <img src={FilePdf} alt="PDF" loading="lazy" />
            <span>
              <strong className="info_portal">{title}</strong>
              <span>{description}</span>
            </span>
          </a>
        </li>
      );
    },
    [selectedLanguage]
  );

  return (
    <div className="background-body">
      <Suspense fallback={<><HomeContentLoader /></>}>
        <NewBanner CMSData={CMSData} />
        <AboutUs CMSData={CMSData} />
        <UsePortal CMSData={CMSData} />
        <FarmerLogin CMSData={CMSData} />
        <Services CMSData={CMSData} />
      </Suspense>

      {/* PDF Section */}
      <Col lg={12} sm={12} className="user_portal_info">
        <ul>{pdfItems.map(renderPDFLink)}</ul>
      </Col>
    </div>
  );
}

export default Index;
